import { FunctionComponent } from 'react';
import { Outlet } from 'react-router-dom';
import { NodeListSubscriber } from '@cbridge-packages/node';
import { SymbolGroupsSubscriber } from '@cbridge-packages/symbol-groups';

export const SymbolsClientDataLayout: FunctionComponent = () => (
  <>
    <NodeListSubscriber includeServers={true} includeStreams={true} />
    <SymbolGroupsSubscriber />
    <Outlet />
  </>
);
